import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import SEO from "../components/SEO";

const NotFound = () => {
  return (
    <div className="min-h-[70vh] flex items-center justify-center px-6 py-20" data-testid="page-404">
      <SEO title="Page Not Found" path="/404" />
      <div className="text-center">
        <div className="font-display text-[10rem] md:text-[14rem] font-bold leading-none text-[#FF5A00]">
          404
        </div>
        <h1 className="font-display text-4xl md:text-5xl uppercase font-bold mt-2">
          Site Not Found
        </h1>
        <p className="mt-4 text-[#52525B] max-w-md mx-auto">
          Looks like this page was demolished. Let's get you back to solid
          ground.
        </p>
        <Link
          to="/"
          className="mt-8 inline-flex items-center gap-2 bg-[#111111] text-white px-7 py-3.5 font-bold uppercase tracking-wide hover:bg-[#FF5A00] transition-colors"
          data-testid="404-home-link"
        >
          <ArrowLeft size={16} /> Back to Home
        </Link>
      </div>
    </div>
  );
};

export default NotFound;
